var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"customHeaderLabel"},[_vm._v(" "+_vm._s(_vm.params.displayName))]),_c('div',{class:_vm.expandOrCollapseClass,on:{"click":_vm.expandOrCollapse}},[_c('i',{staticClass:"fa fa-arrow-right"})])])}
var staticRenderFns = []

export { render, staticRenderFns }